import { Text } from 'foundations-components/components/Text';
import UIIcon from 'UIComponents/icon/UIIcon';
import styled, { css } from 'styled-components';
import { ECLIPSE } from 'developer-docs-shared-components/config/cssConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledH2WithGap = styled(Text).attrs({
  as: 'h2'
}).withConfig({
  displayName: "SectionHeader__StyledH2WithGap",
  componentId: "sc-1due7n6-0"
})(["color:", ";display:flex;align-items:center;gap:10px;margin-bottom:unset;font-weight:500;"], ECLIPSE);
const StyledIcon = styled(UIIcon).withConfig({
  displayName: "SectionHeader__StyledIcon",
  componentId: "sc-1due7n6-1"
})(["font-size:24px;", ""], ({
  name
}) => {
  if (name !== 'bulb') {
    return css(["span::before{position:relative;top:3px;}"]);
  }
  return null;
});
export const SectionHeader = ({
  iconName,
  header
}) => {
  return /*#__PURE__*/_jsxs(StyledH2WithGap, {
    children: [/*#__PURE__*/_jsx(StyledIcon, {
      name: iconName,
      color: ECLIPSE
    }), header]
  });
};